import React, { useState, useEffect, useContext } from 'react'
import axios from "../../../../axios/index"

import { UserContext } from '../../../Context/UserContextProvider';
import { useLocation } from 'react-router-dom';

// components
import HomeNavbar from '../../../Home/HomeNavbar/HomeNavbar';
import UserSideDashboard from '../../UserSideDashboard/UserSideDashboard';
import Footer from '../../../Home/Footer/Footer';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

// styles
import styles from "../AddRequest/AddRequest.module.css";
import Dstyles from "../../UserMyAds/UserMyAds.module.css";
import inputStyles from "../../../Dashboard/DashboardReuseAbleComponents/AddNewFile.module.css"
import loaderStyles from "../../../Dashboard/DashboardFileManagement/DashboardFileManagement.module.css"
import inputStyles2 from "../../../Dashboard/DashboardReuseAbleComponents/AddNewFile.module.css"
import RequestAnswer from './RequestAnswer';

export default function RequestDetail() {
    const { userToken } = useContext(UserContext)
    const { state } = useLocation()
    const [categories, setCategories] = useState()
    const [isLoading, setIsLoading] = useState(true)
    const [showAllData, setShowAllData] = useState(false)
    const [value, setValue] = useState('271');
    const [fileData, setFileData] = useState({
        title: "",
        meter: "",
        startPrice: "",
        endPrice: "",
        facilities: "",
        description: "",
        city: "",
        place: [],
        year: "",
        room: "",
        floor: "",
        consultantSuggestions: "",
        showList: false
    })
    const [facilities, setFacilities] = useState([
        { id: "1", name: "آسانسور", status: false },
        { id: "2", name: "پارکینگ", status: false },
        { id: "3", name: "انباری", status: false },
        { id: "4", name: "بالکن", status: false },
    ]);

    function statusHandler(id) {
        const itemSelected = facilities.find((item) => id === item.id);
        const newState = facilities.map(obj => {
            if (obj.id === id) {
                return { ...obj, status: !itemSelected.status };
            }
            return obj;
        });
        setFacilities(newState);
    }

    useEffect(() => {
        const dataHandler = async () => {
            // setIsLoading(true)
            const apiData = await axios.get(
                "Category/GetParentCategories",
                {
                    headers: { authorization: "Bearer " + userToken },
                }
            );
            setCategories(apiData.data.data)
            setIsLoading(false)
        }
        dataHandler()
    }, [userToken])

    useEffect(() => {
        const dataHandler = async () => {
            const getRequestDetail = await axios.get(
                // `RequestFile/1`,
                `RequestFile/${state.id}`,
                {
                    headers: { authorization: "Bearer " + userToken },
                }
            );

            const data = getRequestDetail.data.data;
            const specifications = data.specifications;
            const selectedPlaces = data.requestFileAreas.map(item => item.value)

            const updatedFacilities = facilities.map(facility => {
                const matchingObject = specifications.find(obj => obj.value === facility.name);
                if (matchingObject) {
                    return { ...facility, status: true };
                } else {
                    return facility;
                }
            });
            setFacilities(updatedFacilities);

            setValue(data.categoryId)
            setFileData((prev) => {
                return { ...prev, title: data.title, meter: data.meterage, startPrice: data.startPrice, endPrice: data.entPrice, description: data.description, city: data.city, year: data.constructionYear, room: data.roomCount, floor: data.floor, facilities: data.specifications, consultantSuggestions: data.consultantSuggestions, place: selectedPlaces };
                // place: data.area,
            });

            setIsLoading(false)
        }

        dataHandler()
    }, [userToken, state])


    return (
        <>
            {isLoading ? (
                <div className={loaderStyles.loader_container}>
                    <div className={loaderStyles.spinner}></div>
                </div>
            )
                : (
                    <div className="d-flex justify-content-center align-items-start vw-100 position-relative" dir='rtl'>
                        <div className="w-100 ms-0 p-0" style={{ background: "#FFFFFF" }}>
                            <HomeNavbar />
                            <div className="container py-3 mt-4">
                                <div className='w-100 d-flex justify-content-md-between justify-content-center align-items-start'>
                                    <UserSideDashboard myReqs />
                                    <div className='d-flex flex-column align-items-center justify-content-center'>
                                        <div className={`d-flex flex-column align-items-center justify-content-start p-4 ${showAllData ? Dstyles.main_container : styles.show_less}`}>
                                            <Title title={fileData?.title} />
                                            <SelectCategory value={value} categories={categories} />
                                            <div className='w-100 d-flex flex-column flex-wrap justify-content-center align-items-center mb-4'>
                                                {/* title */}
                                                <div className="w-100 d-flex align-items-start justify-content-center flex-column mb-4">
                                                    <div className={`mb-3 ${inputStyles.input_header}`}>
                                                        عنوان درخواست
                                                    </div>
                                                    <input
                                                        type="text"
                                                        name="title"
                                                        value={fileData.title}
                                                        className={`w-100 bg-light py-2 pe-3 ${inputStyles.input}`}
                                                        placeholder="مثلا آپارتمان ۳۰۰ متر تختی"
                                                    />
                                                </div>
                                                {/* title */}

                                                {showAllData === true &&
                                                    <>
                                                        {/* details row 1 */}
                                                        <div className="w-100 d-flex align-items-center justify-content-between flex-wrap my-2">
                                                            <InputData value={fileData?.city} name="city" headerText="شهر" />
                                                            <InputData value={fileData?.meter} name="meter" headerText="متراژ حداقل" />
                                                            <InputData value={fileData?.year} name="year" headerText="عمر ساخت" />
                                                        </div>
                                                        {/* details row 1 */}

                                                        {/* details row 2 */}
                                                        <div className="w-100 d-flex align-items-center justify-content-md-start  justify-content-center flex-wrap mt-2 mb-3">
                                                            <InputData value={fileData?.room} name="room" headerText="تعداد اتاق خواب" />
                                                            <InputData className="me-md-4 me-0" value={fileData?.floor} name="floor" headerText="طبقه" />
                                                        </div>
                                                        {/* details row 2 */}

                                                        <SelectedAreas names={fileData?.place} />

                                                        {/* start & end prices*/}
                                                        <PricesData startPrice={fileData?.startPrice} endPrice={fileData?.endPrice} />
                                                        {/* start & end prices*/}

                                                        {/* Checkbox */}
                                                        <div className='w-100 d-flex flex-column justify-content-center align-items-start flex-wrap mt-5 my-4'>
                                                            <div className={`mb-3 ${inputStyles.title_bold}`}>
                                                                امکانات درخواستی
                                                            </div>
                                                            <div className="w-100 d-flex align-items-center justify-content-between flex-wrap">
                                                                {facilities?.map((item) => (
                                                                    <div key={item.id} className='d-flex align-items-center justify-content-center mx-3 mx-md-0'>
                                                                        <Checkbox
                                                                            checked={item.status}
                                                                            onClick={() => statusHandler(item.id)}
                                                                            inputProps={{ 'aria-label': 'controlled' }}
                                                                            size="medium"
                                                                            name="heldOn"
                                                                        />
                                                                        <div className={inputStyles.input_header}>
                                                                            {item.name}
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                        {/* Checkbox */}

                                                        {/* description */}
                                                        <div className='w-100 d-flex flex-column justify-content-center align-items-start my-4'>
                                                            <div className={`mb-3 ${inputStyles.input_header}`}>
                                                                توضیحات
                                                            </div>
                                                            <textarea
                                                                id='menuone'
                                                                type="text"
                                                                name="description"
                                                                className={`w-100 px-3 pt-3 ${inputStyles.textarea}`}
                                                                placeholder="توضیحات خود را وارد کنید"
                                                                value={fileData.description}
                                                            ></textarea>
                                                        </div>
                                                        {/* description */}

                                                    </>
                                                }

                                                <div className="w-100 text-center my-3">
                                                    <button type="" className={`d-flex align-items-center justify-content-center m-auto ${styles.btn_primary}`} onClick={() => setShowAllData(!showAllData)}>
                                                        {showAllData ?
                                                            <>
                                                                مشاهده کمتر
                                                                <svg className='me-2' width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path fillRule="evenodd" clipRule="evenodd" d="M0.598461 0.567211C0.854743 0.31093 1.27026 0.31093 1.52654 0.567211L5 4.04067L8.47346 0.567211C8.72974 0.31093 9.14526 0.31093 9.40154 0.567211C9.65782 0.823493 9.65782 1.23901 9.40154 1.49529L5.46404 5.43279C5.20776 5.68907 4.79224 5.68907 4.53596 5.43279L0.598461 1.49529C0.34218 1.23901 0.34218 0.823493 0.598461 0.567211Z" fill="#21409A" />
                                                                </svg>
                                                            </>
                                                            :
                                                            <>
                                                                مشاهده بیشتر
                                                                <svg className='me-2' width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path fillRule="evenodd" clipRule="evenodd" d="M0.598461 0.567211C0.854743 0.31093 1.27026 0.31093 1.52654 0.567211L5 4.04067L8.47346 0.567211C8.72974 0.31093 9.14526 0.31093 9.40154 0.567211C9.65782 0.823493 9.65782 1.23901 9.40154 1.49529L5.46404 5.43279C5.20776 5.68907 4.79224 5.68907 4.53596 5.43279L0.598461 1.49529C0.34218 1.23901 0.34218 0.823493 0.598461 0.567211Z" fill="#21409A" />
                                                                </svg>
                                                            </>
                                                        }
                                                    </button>
                                                </div>

                                            </div>
                                        </div>
                                        {showAllData === false && fileData.consultantSuggestions ?
                                            <RequestAnswer data={fileData?.consultantSuggestions} />
                                            :
                                            <></>
                                        }
                                    </div>
                                </div>
                            </div>
                            <Footer />
                        </div>
                    </div>
                )}
        </>
    )
}

function Title({ title }) {
    return (
        <div className='w-100 d-flex align-items-center justify-content-md-between justify-content-center flex-wrap mb-5'>
            <div className={`my-md-0 my-2 ${Dstyles.title}`}>
                {title}
            </div>
        </div>
    )
}

export function SelectedAreas({ names }) {
    // const placeName = names[0].split(",");
    return (
        <div className='w-100 d-flex flex-column align-items-start justify-content-center flex-wrap mt-4 mb-3'>
            <div className={`mb-3 ${Dstyles.title}`}>
                مناطق درخواستی :
            </div>
            <div className='w-100 d-flex align-items-center justify-content-between px-2 flex-wrap mt-3'>
                {names?.map((item, i) => (
                    <div key={i} className={`mx-2 ${styles.text_gray}`}>
                        {item}
                    </div>
                ))}
            </div>
        </div>
    )
}

export function InputData({ value, headerText, name, className, managment }) {
    return (
        <>
            {name === "meter" ?
                <div className='d-flex flex-column justify-content-center align-items-start mt-md-0 mt-3'>
                    <div className={`mb-3 ${inputStyles2.input_header}`}>
                        {headerText}
                    </div>
                    <label className='position-relative' htmlFor="metrajPrice">
                        <span className={inputStyles2.input_left_text}>متر</span>
                        <input
                            type="text"
                            name={name}
                            value={value?.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])}
                            className={`bg-light py-2 ps-5 pe-2 text-end ${inputStyles2.input_meter}`}
                            style={{ width: !managment && "232px" }}
                        />
                    </label>
                </div>
                :
                name === "year" ?
                    <div className={`d-flex flex-column justify-content-center align-items-start my-2 ${className}`}>
                        <div className={`mb-3 ${inputStyles2.input_header}`}>
                            {headerText}
                        </div>
                        <input
                            type="text"
                            name={name}
                            value={value === 1 ? "کمتر از ۵ سال" : value === 2 ? "بیشتر از ۵ سال" : value === 3 && "فرقی نمیکند"}
                            className={`bg-light text-right p-2 ${inputStyles2.input_meter}`}
                            style={{ width: !managment && "232px" }}
                        />
                    </div>
                    :
                    name === "room" ?
                        <div className={`d-flex flex-column justify-content-center align-items-start my-2 ${className}`}>
                            <div className={`mb-3 ${inputStyles2.input_header}`}>
                                {headerText}
                            </div>
                            <input
                                type="text"
                                name="room"
                                value={value === 0 ? "فرقی نمیکند" : value?.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])}
                                className={`bg-light text-right p-2 ${inputStyles2.input_meter}`}
                                style={{ width: !managment && "232px" }}
                            />
                        </div>
                        :
                        name === "floor" ?
                            <div className={`d-flex flex-column justify-content-center align-items-start my-2 ${className}`}>
                                <div className={`mb-3 ${inputStyles2.input_header}`}>
                                    {headerText}
                                </div>
                                <input
                                    type="text"
                                    name="floor"
                                    value={value === 0 ? "فرقی نمیکند" : value?.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])}
                                    className={`bg-light text-right p-2 ${inputStyles2.input_meter}`}
                                    style={{ width: !managment && "232px" }}
                                />
                            </div>
                            :
                            <div className={`d-flex flex-column justify-content-center align-items-start my-2 ${className}`}>
                                <div className={`mb-3 ${inputStyles2.input_header}`}>
                                    {headerText}
                                </div>
                                <input
                                    type="text"
                                    name={name}
                                    value={value?.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])}
                                    className={`bg-light text-right p-2 ${inputStyles2.input_meter}`}
                                    style={{ width: !managment && "232px" }}
                                />
                            </div>
            }
        </>
    )
}

export function PricesData({ startPrice, endPrice }) {
    return (
        <>
            <div className="w-100 d-flex flex-column justify-content-center align-items-start flex-wrap mt-4">
                {/* <div className='w-100 d-flex flex-column justify-content-center align-items-start flex-wrap mt-4'></div> */}
                <div
                    className="d-flex justify-content-md-start justify-content-center flex-wrap align-items-center mt-3"
                    dir="rtl"
                >
                    <div className='d-flex flex-column justify-content-center align-items-start flex-wrap'>
                        <div className={`mb-4 ${inputStyles2.title_bold}`}>
                            قیمت ملک
                        </div>
                        <div className='d-flex align-items-center justify-content-center flex-wrap'>
                            <div className='d-flex flex-column justify-content-center align-items-start mb-md-0 mb-3'>
                                <div className={`mb-3 ${inputStyles2.input_header}`}>
                                    از
                                </div>
                                <label className='position-relative' htmlFor="startPrice">
                                    <span className={inputStyles2.input_left_text}>تومان</span>
                                    <input
                                        type="text"
                                        name="startPrice"
                                        value={startPrice?.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,").replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])}
                                        className={`bg-light py-2 ps-5 pe-2 text-end ${inputStyles2.input_meter}`}
                                        style={{ width: "232px" }}
                                    />
                                </label>
                            </div>

                            <div className='d-flex flex-column justify-content-center align-items-start me-md-2 mt-md-0 mt-3'>
                                <div className={`mb-3 ${inputStyles2.input_header}`}>
                                    تا
                                </div>
                                <label className='position-relative' htmlFor="rent">
                                    <span className={inputStyles2.input_left_text}>تومان</span>
                                    <input
                                        type="text"
                                        name="endPrice"
                                        value={endPrice?.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,").replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])}
                                        className={`bg-light py-2 ps-5 pe-2 text-end ${inputStyles2.input_meter}`}
                                        style={{ width: "232px" }}
                                    />
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

function SelectCategory({ value, categories }) {
    return (
        <div className='w-100 d-flex flex-column align-items-start justify-content-center'>
            <h5 className={styles.text_gray}>نوع ملک درخواستی</h5>

            <div className='w-100 d-flex justify-content-between align-items-center flex-wrap my-3'>
                {categories?.map((item) => (
                    <RadioGroup
                        key={item.id}
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        className='d-flex justify-content-md-between justify-content-evenly align-items-center flex-wrap flex-row'
                        value={value}
                    >
                        <FormControlLabel className='me-0 ms-md-5 ms-0' value={item.id} control={<Radio />} label={item.title} />
                    </RadioGroup>
                ))}
                {/* </FormControl> */}
            </div>
        </div>
    )
}
